

export const  handlegclick=(gclick,setGclick)=>{
    setGclick(!gclick)
}
export const handlecondclick=(condclick,setCondclick)=>{
    setCondclick(!condclick)
}
export const handlecatclick=(catclick,setCatclick)=>{
    setCatclick(!catclick)
}


